export default __webpack_public_path__ + "static/Kozarzewski-a05836ac0cc0b02493fd37265b11b7bb.jpg";